exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel\r\n{\r\n  margin: 5%;\r\n  background: transparent;\r\n}\r\n\r\n\r\n\r\n.panel-footer\r\n{\r\n  background-color: #5bc0de;\r\n  color: white;\r\n}\r\n\r\ninput { \r\n    text-transform: uppercase;\r\n}\r\n\r\n\r\n.modal-buy {\r\n  width: 400px;\r\n}\r\n\r\n.modal-footer a {\r\n  margin-left:30px;\r\n}\r\n\r\n.panel-success>.panel-heading {\r\n  color: #0E6E96;\r\n  background-color: #E3ECFB;\r\n  border-color: #E3ECFB;\r\n}\r\n\r\n.btn-warning {\r\n  color: #fff;\r\n  background-color: #0E6E96;\r\n  border-color: #0E6E96;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/produto_pesquisa/produto_pesquisa.component.css
// module id = 361
// module chunks = 2